var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_c('v-container',{staticClass:"perso-raw-data-content",attrs:{"id":"perso-raw-data-content"}},[(_setup.displayPayload.length > 2)?_c('pre',[_vm._v(_vm._s(_setup.displayPayload))]):_c('pre',[_vm._v(_vm._s(_vm.$t('device.history.modal_details.no_data')))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }